import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import IPayPaymentState from '../../types/IPayPaymentState'

const getters: GetterTree<IPayPaymentState, RootState> = {
  getWidgetSessionId: (state) => state.widgetSessionId
}

export default getters
